module.exports = __webpack_public_path__ + "static/media/ke.2bf299df.jpeg";